export enum SourceVideo {
  ASC = 'https://app.supademo.com/embed/cm35o97ri1xap533hw3zyek4a?embed_v=2%22',
  QBFS = 'https://app.supademo.com/embed/cm3499k0918vx533hbhx3ipuu?embed_v=2%22',
  CSV = 'https://app.supademo.com/embed/cm32tdqmu0i3e533huvxyg9h0?embed_v=2%22',
}

export enum ShipStationApiErrors {
  COMPANY_EXISTED = 'COMPANY_ALREADY_EXISTED',
  INVALID_API_KEY = 'INVALID_API_KEY',
  API_KEY_TAKEN = 'API_KEY_ALREADY_TAKEN',
  API_KEY_MISSING = 'API_KEY_MISSING',
  COMPANY_NOT_FOUND = 'COMPANY_NOT_FOUND'
}
